module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_job_banner_variant3_image-b6a623f7cd13c12d5d9758d2592a88f7.jpg";